"use strict";

import dispatcher from "./../dispatcher";
import {Collection} from "vwa/flux";

const vehicleHeatmapStore = new Collection({keyNames: ["vehicle"]});
export default vehicleHeatmapStore;

window.vehicleHeatmapStore = vehicleHeatmapStore;

function createStoreItemFromHeatmap(report){
	return {
		vehicle: report.options.carrier,
		sections: report.result.sections,
		show: {routes: true, stops: true}
	}
}

dispatcher.on('getVehicleHeatmap', (report) => {
	const prevHeatmap = vehicleHeatmapStore.get(report.options.carrier);
	if (prevHeatmap)
		vehicleHeatmapStore.update(report.options.carrier, createStoreItemFromHeatmap(report));
	else
		vehicleHeatmapStore.insert([createStoreItemFromHeatmap(report)]);
});

openedDetailsStore.on('remove', descriptors => {
	vehicleHeatmapStore.remove(descriptors.map(descriptor => descriptor.id));
});

dispatcher.on("showVehicleHeatmapElements", (vehicle, showedElements) => {
	const descriptor = vehicleHeatmapStore.get(vehicle);
	if(!descriptor){
		return;
	}
	descriptor.show = showedElements;
	
	vehicleHeatmapStore.update(vehicle, descriptor);
});

dispatcher.on("logout", () => {
	vehicleHeatmapStore.set(null);
});


// WEBPACK FOOTER //
// ./src/store/vehicleHeatmaps.js